module.exports = __webpack_public_path__ + "img/ys-bg-2.ca182e16.png";